
import { Component, Vue ,Prop, Watch}  from "vue-property-decorator";

@Component({
  components: {},
})
export default class Aterisk extends Vue {
    @Prop({default:""}) title:string
    @Prop({default:""}) value:string
    @Prop({default:""}) description:string
    @Prop({default:false}) isSelected:boolean
    @Prop({default:1}) displayMode:Number; 
    @Prop({default:null}) index : number;
    public itemSelected(){
        this.$emit("itemSelected",this.value)
    }

    mounted(){
       if(this.index != null && this.index == 0){
        this.$emit("itemSelected",this.value)
       }
    }
     
}
